module.exports = __webpack_public_path__ + "/images/ico-success-regalo.89c3cda.svg";